export function plural(number, words) {
    return number + ' ' +words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
}

const reservationTypeLabels = {
    group: 'Групповая',
    personal: 'Персональная',
    rent: 'Аренда'
}

export function getReservationTypeLabel(type) {
    return reservationTypeLabels[type] || 'Запись'
}

export function getReservationTrainer(type, replacementTrainer, trainer) {
    if (type !== 'personal' && replacementTrainer) {
        return replacementTrainer
    }

    return trainer || null
}

export function getTrainerDisplayName(trainer) {
    if (!trainer) {
        return ''
    }

    return [trainer.surname, trainer.name].filter(Boolean).join(' ')
}

const widgetScriptLoaders = new Map();

function getGlobalScope() {
    if (typeof window !== 'undefined') {
        return window;
    }

    if (typeof self !== 'undefined') {
        return self;
    }

    return {};
}

function loadWidgetScript(src, globalName) {
    const globalScope = getGlobalScope();
    if (globalScope[globalName]) {
        return Promise.resolve(globalScope[globalName]);
    }

    if (widgetScriptLoaders.has(src)) {
        return widgetScriptLoaders.get(src);
    }

    const loader = new Promise((resolve, reject) => {
        if (typeof document === 'undefined') {
            reject(new Error(`${globalName} is not available`));
            return;
        }

        const existingScript = document.querySelector(`script[src="${src}"]`);
        if (existingScript) {
            existingScript.addEventListener('load', () => resolve(globalScope[globalName]), { once: true });
            existingScript.addEventListener('error', () => reject(new Error(`Failed to load ${globalName}`)), { once: true });

            if (globalScope[globalName]) {
                resolve(globalScope[globalName]);
            }
            return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve(globalScope[globalName]);
        script.onerror = () => reject(new Error(`Failed to load ${globalName}`));
        document.head.appendChild(script);
    });

    widgetScriptLoaders.set(src, loader);
    return loader;
}

async function getCloudPaymentsWidget() {
    const globalScope = getGlobalScope();
    const cloudPayments = globalScope.cp || await loadWidgetScript('https://widget.cloudpayments.ru/bundles/cloudpayments', 'cp');
    if (!cloudPayments?.CloudPayments) {
        throw new Error('CloudPayments widget is unavailable');
    }

    return new cloudPayments.CloudPayments();
}

async function getPayselectionWidget() {
    const globalScope = getGlobalScope();
    const payselection = globalScope.pw || await loadWidgetScript('https://widget.payselection.com/lib/pay-widget.js', 'pw');
    if (!payselection?.PayWidget) {
        throw new Error('Payselection widget is unavailable');
    }

    return new payselection.PayWidget();
}

async function getTipTopWidget() {
    const globalScope = getGlobalScope();
    const tipTop = globalScope.tiptop || await loadWidgetScript('https://widget.tiptoppay.kz/bundles/widget.js', 'tiptop');
    if (!tipTop?.Widget) {
        throw new Error('TipTop widget is unavailable');
    }

    return new tipTop.Widget();
}

async function getYooKassaCheckoutWidget() {
    const globalScope = getGlobalScope();
    const checkoutWidget = globalScope.YooMoneyCheckoutWidget
        || await loadWidgetScript('https://yookassa.ru/checkout-widget/v1/checkout-widget.js', 'YooMoneyCheckoutWidget');
    if (!checkoutWidget) {
        throw new Error('YooKassa widget is unavailable');
    }

    return checkoutWidget;
}

export async function cloudPaymentsPayWidget(apiKey, invoiceId, amount, currency, clientId, email, JsonData = {}) {
    const widget = await getCloudPaymentsWidget();
    return new Promise((resolve) => {
        widget.pay('charge',
            {
                publicId: apiKey,
                description: 'Покупка в личном кабинете FitBase',
                amount: amount,
                currency: currency,
                email: email,
                accountId: clientId,
                invoiceId: invoiceId,
                autoClose: 3,
                data: JsonData
            },
            {
                onSuccess() {
                    resolve(true)
                },
                onFail(reason) {
                    console.log('fail payment', reason)
                    resolve(false)
                },
            }
        )
    })
}

export async function payselectionPayWidget(invoiceId, amount, currency, clientId, email, JsonData = {}) {
    const widget = await getPayselectionWidget();
    return new Promise((resolve) => {
        console.log(JsonData, 'JsonData');
        let paymentData =   {
            MetaData: {
                PaymentType: "Pay",
            },
            PaymentRequest: {
                OrderId: invoiceId.toString(),
                Amount: amount.toString(),
                Currency: currency,
                Description: 'Покупка в личном кабинете FitBase',
            },
            CustomerInfo: {
                UserId: clientId.toString(),
                Email: email ? email : undefined,
                ReceiptEmail: email ? email : undefined,
            },
        };
        if (JsonData.receiptData) {
            paymentData.ReceiptData = JsonData.receiptData;
        }

        console.log({
            serviceId: JsonData.serviceId,
            key: JsonData.publicKey,
            only2Level: JsonData.only2Level,
            paymentData: paymentData,
        }, 'payselection widget data');

        widget.pay(
            {
                serviceId: JsonData.serviceId,
                key: JsonData.publicKey,
                // logger:true,
            },
            paymentData,
            {
                onSuccess: function(res) {
                    console.log("onSuccess from shop", res);
                    resolve(true);
                },
                onError: function(res) {
                    console.log("onFail from shop", res);
                    resolve(false);
                },
                onClose: function(res) {
                    console.log("onClose from shop", res);
                    resolve(false);
                },
            },
            // необязательный параметр, необходим для корректной работы при наличии сайтов с поддоменами
            // {only2Level: JsonData.only2Level}
        );
    });
}

export async function tipTopPayWidget(invoiceId, amount, currency, clientId, email, JsonData = {}) {
    const widget = await getTipTopWidget();
    return new Promise((resolve) => {
        widget.pay('charge',
            {
                publicId: JsonData.publicKey,
                description: 'Покупка в личном кабинете FitBase',
                amount: amount,
                currency: currency,
                email: email,
                accountId: clientId,
                invoiceId: invoiceId,
                autoClose: 3,
                data: JsonData
            },
            {
                onSuccess() {
                    resolve(true)
                },
                onFail(reason) {
                    console.log('fail payment', reason)
                    resolve(false)
                },
            }
        )
    })
}

export async function yooKassaPayWidget(invoiceId, JsonData = {}) {
    const confirmationToken = JsonData.confirmationToken
    if (!confirmationToken) {
        console.log('yookassa: missing confirmationToken', JsonData)
        return Promise.resolve(false)
    }

    let CheckoutWidget
    try {
        CheckoutWidget = await getYooKassaCheckoutWidget()
    } catch (error) {
        console.log('yookassa: widget script not loaded', error)
        return Promise.resolve(false)
    }

    const mount = createYooKassaCardMount()
    let finish = () => {}
    const checkout = new CheckoutWidget({
        confirmation_token: confirmationToken,
        return_url: JsonData.returnUrl || window.location.href,
        customization: {
            modal: false,
        },
        error_callback: function(error) {
            console.log('yookassa error_callback', error)
            finish(false)
        },
    })

    return new Promise((resolve) => {
        let finished = false
        finish = (value) => {
            if (finished) {
                return
            }
            finished = true
            try {
                checkout.destroy()
            } catch (e) {
                console.log('yookassa destroy error', e)
            }
            mount.destroy()
            resolve(value)
        }

        checkout.on('success', function() {
            console.log('yookassa success', invoiceId)
            finish(true)
        })

        checkout.on('fail', function(event) {
            console.log('yookassa fail', event, invoiceId)
            finish(false)
        })

        checkout.on('complete', function(event) {
            console.log('yookassa complete', event, invoiceId)
        })

        mount.closeButton.addEventListener('click', function() {
            finish(false)
        })

        mount.overlay.addEventListener('click', function(event) {
            if (event.target === mount.overlay) {
                finish(false)
            }
        })

        const renderResult = checkout.render(mount.containerId)
        if (renderResult && typeof renderResult.catch === 'function') {
            renderResult.catch((error) => {
                console.log('yookassa render error', error, invoiceId)
                finish(false)
            })
        }
    })
}

function createYooKassaCardMount() {
    const styleId = 'yookassa-card-widget-style'
    if (!document.getElementById(styleId)) {
        const style = document.createElement('style')
        style.id = styleId
        style.textContent = `
            .yookassa-card-overlay {
                position: fixed;
                inset: 0;
                z-index: 9999;
                display: flex;
                align-items: flex-start;
                justify-content: center;
                padding: 24px 16px 16px;
                background: rgba(17, 24, 39, 0.58);
                backdrop-filter: blur(4px);
            }

            .yookassa-card-shell {
                position: relative;
                width: 100%;
                max-width: 640px;
                max-height: calc(100vh - 40px);
                overflow: auto;
                padding: 16px 16px 12px;
                border-radius: 24px;
                background: #ffffff;
                box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
            }

            .yookassa-card-close {
                position: absolute;
                top: 12px;
                right: 12px;
                width: 36px;
                height: 36px;
                border: 0;
                border-radius: 999px;
                background: #f3f4f6;
                color: #111827;
                font-size: 22px;
                line-height: 1;
                cursor: pointer;
            }

            .yookassa-card-container {
                min-height: 700px;
                min-width: 100%;
                padding-top: 24px;
            }

            .yookassa-card-container iframe {
                display: block;
                width: 100% !important;
                min-height: 700px !important;
            }

            @media (max-width: 576px) {
                .yookassa-card-overlay {
                    padding: 12px;
                }

                .yookassa-card-shell {
                    padding: 12px 12px 8px;
                    border-radius: 18px;
                    max-height: calc(100vh - 24px);
                }

                .yookassa-card-container {
                    min-height: 620px;
                    padding-top: 20px;
                }

                .yookassa-card-container iframe {
                    min-height: 620px !important;
                }
            }
        `
        document.head.appendChild(style)
    }

    const overlay = document.createElement('div')
    overlay.className = 'yookassa-card-overlay'

    const shell = document.createElement('div')
    shell.className = 'yookassa-card-shell'

    const closeButton = document.createElement('button')
    closeButton.type = 'button'
    closeButton.className = 'yookassa-card-close'
    closeButton.setAttribute('aria-label', 'Закрыть оплату')
    closeButton.textContent = '\u00d7'

    const container = document.createElement('div')
    const containerId = 'yookassa-card-container-' + Date.now()
    container.id = containerId
    container.className = 'yookassa-card-container'

    shell.appendChild(closeButton)
    shell.appendChild(container)
    overlay.appendChild(shell)
    document.body.appendChild(overlay)
    document.body.classList.add('modal-open')

    return {
        overlay,
        closeButton,
        containerId,
        destroy() {
            overlay.remove()
            if (!document.querySelector('.modal.show') && !document.querySelector('.yookassa-card-overlay')) {
                document.body.classList.remove('modal-open')
            }
        },
    }
}

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

function getErrorMessage(error) {
    return error?.response?.data?.message || error?.message || ''
}

const ATMOS_PENDING_INVOICE_KEY = 'fitbase_atmos_pending_invoice_id'

export function openAtmosPopupTab() {
    try {
        return window.open('', '_blank')
    } catch (e) {
        console.log('atmos: failed to pre-open tab', e)
        return null
    }
}

function navigateAtmosTab(popup, paymentLink) {
    if (popup && !popup.closed) {
        try {
            popup.location.replace(paymentLink)
            return { mode: 'tab', popup }
        } catch (e) {
            console.log('atmos: failed to navigate pre-opened tab', e)
        }
    }

    navigateToPaymentPage(paymentLink)
    return { mode: 'redirect', popup: null }
}

export function atmosRedirectPay(invoiceId, JsonData = {}, popup = null) {
    const paymentLink = JsonData.paymentLink
    if (!paymentLink) {
        console.log('atmos: missing paymentLink', JsonData)
        try {
            popup?.close()
        } catch (e) {
            console.log('atmos: failed to close pre-opened tab', e)
        }
        return false
    }

    try {
        sessionStorage.setItem(ATMOS_PENDING_INVOICE_KEY, String(invoiceId))
    } catch (e) {
        console.log('atmos: sessionStorage unavailable', e)
    }

    return navigateAtmosTab(popup, paymentLink)
}

export function takePendingAtmosInvoiceId() {
    let invoiceId = null
    try {
        invoiceId = sessionStorage.getItem(ATMOS_PENDING_INVOICE_KEY)
        if (invoiceId) {
            sessionStorage.removeItem(ATMOS_PENDING_INVOICE_KEY)
        }
    } catch (e) {
        console.log('atmos: sessionStorage unavailable', e)
    }

    return invoiceId
}

const ATMOS_PENDING_CARD_BIND_INVOICE_KEY = 'fitbase_atmos_pending_card_bind_invoice_id'

export function atmosRedirectCardBind(invoiceId, JsonData = {}, popup = null) {
    const paymentLink = JsonData.paymentLink
    if (!paymentLink) {
        console.log('atmos card bind: missing paymentLink', JsonData)
        try {
            popup?.close()
        } catch (e) {
            console.log('atmos card bind: failed to close pre-opened tab', e)
        }
        return false
    }

    try {
        // knownCardIds — снимок карт клиента на момент клика "Привязать карту". ATMOS уводит браузер
        // на свою страницу и обратно на статическую /acquiring/atmos/card-bind-success (а не на этот
        // роут ЛК) — клиент может вернуться в ЛК только через ручной клик по ссылке спустя произвольное
        // время. Без этого снимка, взятого ДО редиректа, при возврате нельзя отличить "карта уже была
        // привязана до этого захода" от "эта попытка ещё не завершилась" — id новой карты сравнивать
        // не с чем (`actionCards()` не отдаёт `addition_invoice_id`).
        sessionStorage.setItem(ATMOS_PENDING_CARD_BIND_INVOICE_KEY, JSON.stringify({
            invoiceId: String(invoiceId),
            knownCardIds: JsonData.knownCardIds || [],
        }))
    } catch (e) {
        console.log('atmos card bind: sessionStorage unavailable', e)
    }

    return navigateAtmosTab(popup, paymentLink)
}

export function takePendingAtmosCardBind() {
    let pending = null
    try {
        const raw = sessionStorage.getItem(ATMOS_PENDING_CARD_BIND_INVOICE_KEY)
        if (raw) {
            sessionStorage.removeItem(ATMOS_PENDING_CARD_BIND_INVOICE_KEY)
            pending = JSON.parse(raw)
        }
    } catch (e) {
        console.log('atmos card bind: sessionStorage unavailable', e)
    }

    return pending
}

const RETURN_URL_MAX_LENGTH = 2048
const PENDING_PAYMENT_STORAGE_KEY = 'fitbase_pending_payment'
const PENDING_PAYMENT_TTL_MS = 1800000

/** Приложение, которое начало оплату: у виджета и личного кабинета свои обработчики возврата */
export const PAYMENT_SCOPE_BOOKING_WIDGET = 'booking-widget'
export const PAYMENT_SCOPE_PERSONAL_ACCOUNT = 'personal-account'

/**
 * Страница, с которой клиент начал оплату: передаём её в createInvoice, чтобы
 * эквайринги со своей страницей оплаты (Яндекс Пэй) вернули клиента сюда же
 *
 * @returns {string}
 */
export function getPaymentReturnUrl() {
    try {
        const url = window.self !== window.top && document.referrer
            ? document.referrer
            : window.location.href

        return url.length > RETURN_URL_MAX_LENGTH ? '' : url
    } catch (error) {
        console.log('failed to resolve payment return url', error)
        return ''
    }
}

/**
 * Запоминает начатую оплату перед уходом на страницу эквайринга
 *
 * @param {object} payment {scope, invoiceId, ...контекст приложения}
 * @returns {boolean}
 */
export function savePendingPayment(payment) {
    try {
        window.sessionStorage.setItem(PENDING_PAYMENT_STORAGE_KEY, JSON.stringify({
            ...payment,
            createdAt: Date.now(),
        }))

        return true
    } catch (error) {
        console.log('failed to save pending payment', error)
        return false
    }
}

/**
 * Забирает оплату, начатую до ухода на страницу эквайринга, и сразу удаляет запись
 * @param {string} scope одна из PAYMENT_SCOPE_*
 * @returns {object|null}
 */
export function takePendingPayment(scope) {
    let pending = null

    try {
        pending = JSON.parse(window.sessionStorage.getItem(PENDING_PAYMENT_STORAGE_KEY))
    } catch (error) {
        console.log('failed to read pending payment', error)
        return null
    }

    if (!pending || pending.scope !== scope) {
        return null
    }

    try {
        window.sessionStorage.removeItem(PENDING_PAYMENT_STORAGE_KEY)
    } catch (error) {
        console.log('failed to clear pending payment', error)
    }

    if (!pending.invoiceId || Date.now() - Number(pending.createdAt || 0) > PENDING_PAYMENT_TTL_MS) {
        return null
    }

    return pending
}

export const YANDEX_PAY_MIN_SPLIT_AMOUNT = 10
export const YANDEX_PAY_MAX_SPLIT_AMOUNT = 50000
const YANDEX_PAY_SDK_URL = 'https://pay.yandex.ru/sdk/v1/pay.js'

function formatYandexPayAmount(amount) {
    return Number(amount).toFixed(2)
}

function resolveYandexPayCurrencyCode(YaPay, currency) {
    const normalizedCurrency = String(currency || 'RUB').toUpperCase()
    const currencyCodes = YaPay?.CurrencyCode || {}

    return currencyCodes[normalizedCurrency]
        || currencyCodes.Rub
        || currencyCodes.RUB
        || normalizedCurrency
}

export function buildYandexPayWidgetConfig(settings, amount, currency = 'RUB') {
    const paymentTypes = settings?.modules?.payment_types
    if (paymentTypes?.online?.acquiring_integration_type !== 'yandex_pay') {
        return null
    }

    const yandexPay = paymentTypes?.yandex_pay
    if (!yandexPay?.merchantId || !yandexPay?.isSplitEnabled) {
        return null
    }

    const numericAmount = Number(amount)
    if (
        !Number.isFinite(numericAmount)
        || numericAmount < YANDEX_PAY_MIN_SPLIT_AMOUNT
        || numericAmount > YANDEX_PAY_MAX_SPLIT_AMOUNT
    ) {
        return null
    }

    return {
        merchantId: yandexPay.merchantId,
        totalAmount: formatYandexPayAmount(numericAmount),
        currencyCode: String(currency || 'RUB').toUpperCase(),
        environment: yandexPay.environment || 'PRODUCTION',
        availablePaymentMethods: ['CARD', 'SPLIT'],
    }
}

async function getYandexPaySdk() {
    const YaPay = await loadWidgetScript(YANDEX_PAY_SDK_URL, 'YaPay')
    if (!YaPay?.createSession) {
        throw new Error('Yandex Pay SDK is unavailable')
    }

    return YaPay
}

function buildYandexPaySessionPaymentData(YaPay, config) {
    return {
        env: config.environment === 'SANDBOX'
            ? YaPay.PaymentEnv.Sandbox
            : YaPay.PaymentEnv.Production,
        version: 4,
        currencyCode: resolveYandexPayCurrencyCode(YaPay, config.currencyCode),
        merchantId: config.merchantId,
        totalAmount: config.totalAmount,
        availablePaymentMethods: config.availablePaymentMethods,
    }
}

/**
 * Информационный виджет Яндекс Пэй
 *
 * @param {HTMLElement} container
 * @param {object} config
 * @returns {Promise<boolean>}
 */
export async function mountYandexPayInfoWidget(container, config) {
    if (!container || !config) {
        return false
    }

    unmountYandexPayInfoWidget(container)

    try {
        const YaPay = await getYandexPaySdk()
        const session = await YaPay.createSession(
            buildYandexPaySessionPaymentData(YaPay, config),
            {
                onPayButtonClick: async () => {
                    throw new Error('Yandex Pay checkout is handled separately')
                },
                onFormOpenError: (reason) => {
                    console.log('yandex pay info widget form open error', reason)
                },
            },
        )

        container._yandexPaySession = session
        session.mountWidget(container, {
            widgetType: YaPay.WidgetType.Ultimate,
            hasCheckoutButton: false,
        })

        return true
    } catch (error) {
        console.log('yandex pay info widget mount failed', error)
        return false
    }
}

export function unmountYandexPayInfoWidget(container) {
    if (!container?._yandexPaySession) {
        return
    }

    try {
        container._yandexPaySession.unmountWidget(container)
    } catch (error) {
        console.log('yandex pay info widget unmount error', error)
    }

    container._yandexPaySession = null
}

/**
 * Уводит на страницу оплаты вкладку целиком
 */
function navigateToPaymentPage(paymentUrl) {
    try {
        if (window.top && window.top !== window.self) {
            window.top.location.assign(paymentUrl)
            return
        }
    } catch (error) {
        console.log('failed to redirect top window to payment page', error)
    }

    window.location.assign(paymentUrl)
}

/**
 * Яндекс Пэй отдаёт не виджет, а ссылку на свою страницу оплаты (paymentUrl).
 * Уводим туда текущую вкладку и запоминаем счёт: оплата, отмена и ошибка ведут на один
 * и тот же returnUrl, поэтому после возврата приложение опрашивает счёт и показывает итог.
 *
 * @param {object} JsonData данные из AcquiringYandexPayApiAdapter::getSdkData()
 * @param {object} pendingPayment контекст оплаты для обработчика возврата
 * @returns {Promise<boolean>} не резолвится при удачном старте: вкладка уходит на оплату
 */
export async function startYandexPayRedirect(JsonData = {}, pendingPayment = {}) {
    const paymentUrl = JsonData.paymentUrl
    if (!paymentUrl) {
        console.log('yandex pay: missing paymentUrl', JsonData)
        return false
    }

    savePendingPayment(pendingPayment)
    navigateToPaymentPage(paymentUrl)

    return new Promise(() => {})
}

/**
 * Ждёт, пока вебхук эквайринга закроет счёт: сразу после возврата оплата ещё может быть в пути
 *
 * @param {function(): Promise<*>} checkInvoice
 * @param {object} options
 * @returns {Promise<*>} ответ проверки счёта либо false
 */
export async function waitForPaidInvoice(checkInvoice, options = {}) {
    const maxAttempts = options.maxAttempts ?? 8
    const retryDelayMs = options.retryDelayMs ?? 1500

    for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
        try {
            const result = await checkInvoice()
            if (result) {
                return result
            }
        } catch (error) {
            console.log('invoice is not paid yet', getErrorMessage(error))
        }

        if (attempt < maxAttempts) {
            await sleep(retryDelayMs)
        }
    }

    return false
}

export const ATMOS_RETURN_MESSAGE_SOURCE = 'fitbase-atmos-return'

function waitForPopupSignalOrTimeout(popup, timeoutMs) {
    return new Promise((resolve) => {
        let settled = false

        const finish = () => {
            if (settled) {
                return
            }
            settled = true
            window.removeEventListener('message', onMessage)
            clearTimeout(timer)
            resolve()
        }

        const onMessage = (event) => {
            if (event.source === popup && event.data?.source === ATMOS_RETURN_MESSAGE_SOURCE) {
                finish()
            }
        }

        window.addEventListener('message', onMessage)
        const timer = setTimeout(finish, timeoutMs)
    })
}

export async function waitForAtmosTabResult(popup, checkResult, options = {}) {
    const maxWaitMs = options.maxWaitMs ?? 5 * 60 * 1000
    const fastPhaseMs = options.fastPhaseMs ?? 30 * 1000
    const fastIntervalMs = options.fastIntervalMs ?? 2000
    const slowIntervalMs = options.slowIntervalMs ?? 5000
    const attemptsAfterClose = options.attemptsAfterClose ?? 3
    let attemptsSinceClose = 0
    let elapsedMs = 0

    while (elapsedMs < maxWaitMs) {
        if (options.isCancelled?.()) {
            return false
        }

        try {
            const result = await checkResult()
            if (result) {
                return result
            }
        } catch (error) {
            console.log('atmos tab result is not confirmed yet', getErrorMessage(error))
        }

        if (popup?.closed) {
            attemptsSinceClose += 1
            if (attemptsSinceClose >= attemptsAfterClose) {
                return false
            }
        }

        const delayMs = elapsedMs < fastPhaseMs ? fastIntervalMs : slowIntervalMs
        await waitForPopupSignalOrTimeout(popup, delayMs)
        elapsedMs += delayMs
    }

    return false
}

export function createAtmosTabWaiter({ setState }) {
    let popup = null
    let paymentLink = null
    let checkResult = null
    let cancelled = false

    async function safeCheck() {
        try {
            return await checkResult()
        } catch (error) {
            console.log('atmos tab check failed', getErrorMessage(error))
            return false
        }
    }

    async function start(nextPopup, nextCheckResult, nextPaymentLink = null) {
        popup = nextPopup
        checkResult = nextCheckResult
        paymentLink = nextPaymentLink
        cancelled = false
        setState({ active: true, timedOut: false })

        const result = await waitForAtmosTabResult(popup, safeCheck, {
            isCancelled: () => cancelled
        })

        if (cancelled) {
            return false
        }

        if (result) {
            setState({ active: false, timedOut: false })
            return result
        }

        setState({ active: true, timedOut: true })
        return false
    }

    async function retry() {
        if (!checkResult) {
            return false
        }

        setState({ active: true, timedOut: false })
        const result = await safeCheck()

        if (result) {
            setState({ active: false, timedOut: false })
            return result
        }

        setState({ active: true, timedOut: true })
        return false
    }

    function cancel() {
        cancelled = true
        setState({ active: false, timedOut: false })
    }

    function reopen() {
        if (popup && !popup.closed) {
            try {
                popup.focus()
                return
            } catch (e) {
                console.log('atmos: failed to focus tab', e)
            }
        }

        if (!paymentLink) {
            return
        }

        try {
            popup = window.open(paymentLink, '_blank')
        } catch (e) {
            console.log('atmos: failed to reopen tab', e)
        }
    }

    return { start, retry, cancel, reopen }
}

export async function checkInvoiceWithRetry(api, invoiceId, saveCard = 1, options = {}) {
    const maxAttempts = options.maxAttempts ?? 8
    const retryDelayMs = options.retryDelayMs ?? 1500

    for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
        try {
            const result = await api.payment.checkInvoice({
                params: {
                    save_card: saveCard,
                    invoiceId,
                }
            })
            if (result || attempt === maxAttempts) {
                return result
            }
        } catch (error) {
            const message = getErrorMessage(error)
            const isPendingState = message.includes('Транзакция находится в обработке')
                || message.includes('Оплата находится в стадии проверки')

            if (!isPendingState || attempt === maxAttempts) {
                throw error
            }
        }

        await sleep(retryDelayMs)
    }

    return false
}
